/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { PBSLink } from '../../../atoms/link';
import NewGluCard from '../new-home-glu-cards';

function GluAllCourses({ coursesData, title, link, linkText, locale }) {
	const total = coursesData.length;
	return (
		<>
			<div>
				<div className="flex pr-5 pl-5 justify-between">
					<h1 className="text-xl glumd:text-3xl gluxs:text-sm glu2xl:text-2xl  font-bold text-black">
						{title} ({total} Sessions)
					</h1>
					{coursesData.length > 5 && (
						<PBSLink
							to={link}
							variant="Unset"
							className="text-blue-400"
						>
							{linkText}
						</PBSLink>
					)}
				</div>
				<div className="my-6 overflow-x-scroll carousel-hide-scrollbar pb-5 mr-1">
					<div className="grid grid-flow-col auto-cols-max sm:auto-cols-max md:auto-cols-max glu2xl:grid-cols-5 w-full gap-5 p-2">
						{coursesData.slice(0, 5).map((data, index) => (
							<NewGluCard
								key={index}
								data={data}
								compact
								locale={locale}
							/>
						))}
					</div>
				</div>
			</div>
		</>
	);
}

export default GluAllCourses;
